<template>
  <div class>
      <section v-for="(item, index) in subBody" :key="index" class="summary">
        <div>
        <p>
          <span class="p-name">{{ item.NAME }}</span>
          <span class="p-title"><label>工号：</label>{{ item.EMPLID }}</span>
        </p>
        <p>
          <label>{{ item.C_AFFILIATED_UNIT }}&nbsp;&nbsp;{{ item.STD_POSN }} / {{ item.DEPT }}</label>
        </p>
        <p v-if="item.TYPE == 10">
          <span class="p-10"><label>将于</label> {{ item.C_TRIAL_EXPIRE_DT | datefmt }} <label>转正</label></span>          
        </p>
        <p v-if="item.TYPE == 20">
          <span class="p-20"><label>合同将于</label> {{ item.C_CONTR_EXPIRE_DT | datefmt }} <label>到期</label></span>          
        </p>
        </div>
      </section>
  </div>
</template>
 
<script>
import dateformat from "@/utils/dateformat";

export default {
  props: ["subBody"],
  methods: {},
  filters: {
    datefmt(val) {
      if (!val) return "";
      return dateformat("yyyy/MM/dd", new Date(val));
    },
  },
};
</script>
 
<style lang = "less" scoped>
.summary {
  margin: 10px 16px 0;
  padding:10px 10px;
  background:white;
  border-radius: 10px;            
  div{
    font-size:14px;
    line-height:30px;
    p {
      span {
        color:black;
      }
      span.p-name{
        font-size:1.1rem;
      }
      span.p-title {
        float:right;
      }
      span.p-10{
        color:red;
      }
      span.p-20{
        color:red;
      }
      label {
        color:#aaa !important;
      }
    }
  }
}
</style>